import { lazy } from "react";

export { HOLIDAY_SETTINGS_PATH } from "./holiday-settings-path";
export const HolidaySettings = lazy(() => import("./holiday-settings"));
